const DEFAULT_DATA = []
const DEFAULT_SUMMARY = null
const DEFAULT_PARAMS = {}
const DEFAULT_ACTIVE_TAB_KEY = null
const DEFAULT_ACTIVE_TAB = 0
const DEFAULT_BATCH_REVERSE_GEOCODE = false
const DEFAULT_REPORT_COLUMN_CONFIG = null

const state = {
  data: DEFAULT_DATA,
  summary: DEFAULT_SUMMARY,
  params: DEFAULT_PARAMS,
  activeTabKey: DEFAULT_ACTIVE_TAB_KEY,
  activeTab: DEFAULT_ACTIVE_TAB,
  batchReverseGeocode: DEFAULT_BATCH_REVERSE_GEOCODE,
  reportColumnConfig: DEFAULT_REPORT_COLUMN_CONFIG
}

const getters = {
  getData: state => state.data,
  getSummary: state => state.summary,
  getParams: state => state.params,
  getActiveTabKey: state => state.activeTabKey,
  getActiveTab: state => state.activeTab,
  getBatchReverseGeocode: state => state.batchReverseGeocode,
  getReportColumnConfig: state => state.reportColumnConfig
}

const actions = {
  setData ({ commit }, data) {
    commit('SET_DATA', data)
  },

  setSummary ({ commit }, data) {
    commit('SET_SUMMARY', data)
  },

  setParams ({ commit }, data) {
    commit('SET_PARAMS', data)
  },

  setActiveTabKey ({ commit }, data) {
    commit('SET_ACTIVE_TAB_KEY', data)
  },

  setActiveTab ({ commit }, data) {
    commit('SET_ACTIVE_TAB', data)
  },

  setBatchReverseGeocode ({ commit }, data) {
    commit('SET_BATCH_REVERSE_GEOCODE', data)
  },

  setReportColumnConfig ({ commit }, data) {
    commit('SET_REPORT_COLUMN_CONFIG', data)
  },

  resetAll ({ commit }) {
    commit('RESET_ALL')
  }
}

const mutations = {
  SET_DATA: (state, payload) => (state.data = payload),

  SET_SUMMARY: (state, payload) => (state.summary = payload),

  SET_PARAMS: (state, payload) => (state.params = payload),

  SET_ACTIVE_TAB_KEY: (state, payload) => (state.activeTabKey = payload),

  SET_ACTIVE_TAB: (state, payload) => (state.activeTab = payload),

  SET_BATCH_REVERSE_GEOCODE: (state, payload) => (state.batchReverseGeocode = payload),

  SET_REPORT_COLUMN_CONFIG: (state, payload) => (state.reportColumnConfig = payload),

  RESET_ALL: (state, payload) => {
    state.data = DEFAULT_DATA
    state.summary = DEFAULT_SUMMARY
    state.params = DEFAULT_PARAMS
    state.activeTabKey = DEFAULT_ACTIVE_TAB_KEY
    state.activeTab = DEFAULT_ACTIVE_TAB
    state.batchReverseGeocode = DEFAULT_BATCH_REVERSE_GEOCODE
    state.reportColumnConfig = DEFAULT_REPORT_COLUMN_CONFIG
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
